import Vue from 'vue'
import grid from './grid.vue'
import edit from './edit.vue'
import select from './select.vue'

Vue.component('app-acessomodulo-grid', grid)
Vue.component('app-acessomodulo-edit', edit)
Vue.component('app-acessomodulo-select', select)
